import { ChangeDetectionStrategy, Component, inject, input, model, OnInit, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { InsuredSidebarStateService } from '../../services/insured-sidebar-state.service'
import { ScrollerModule } from 'primeng/scroller'
import { SkeletonModule } from 'primeng/skeleton'
import { LazyLoadEvent } from 'primeng/api'
import { ListViewInsuredListItem } from '@app/layout/sidebar/components/listview-insured/list-view-insured-list-item/list-view-insured-list-item'
import { ItemSnappedHeightDirective } from '@directives/item-snapped-height.directive'

@Component({
  selector: 'albert-listview-insured',
  standalone: true,
  imports: [CommonModule, ScrollerModule, SkeletonModule, ListViewInsuredListItem, ItemSnappedHeightDirective],
  templateUrl: './list-view-insured.component.html',
  styleUrl: './list-view-insured.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewInsuredComponent implements OnInit {
  public readonly entrySelected = output()
  public readonly selectedUuid = input<string | null>(null)
  public readonly sidebarDrawerVisible = model(false)
  public readonly itemSize = 58
  public readonly pageSize = 20
  private readonly sidebarState = inject(InsuredSidebarStateService)
  public readonly insuredItems$ = this.sidebarState.insuredList$
  public readonly loading$ = this.sidebarState.loading$

  public ngOnInit(): void {
    this.sidebarState.ensureLoaded(this.pageSize).subscribe()
  }

  public onLazyLoad(event: LazyLoadEvent): void {
    const last = event.last ?? 0
    const page = Math.floor(last / this.pageSize)
    this.sidebarState.loadMoreInsuredItems(page, this.pageSize).subscribe()
  }

  public closeSidebarDrawer(): void {
    this.sidebarDrawerVisible.set(false)
  }

  public onEntrySelected(): void {
    this.entrySelected.emit()
    this.closeSidebarDrawer()
  }
}
